import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import MBOrganizationChart from "./MBOrgChart/MBOrganizationChart";
import orgInfo from "../../../services/orgInfo";

const MBOrgChart = () => {
  // State to hold organization chart data
  const [orgChartData, setOrgChartData] = useState<any>({});
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const customerName = location.search.split('customer_name=');

  // Function to fetch and process organization chart data
  const load = async () => {
    try {
      // Fetch data from sfdc endpoint
      const queryDomain = queryParams.get("domain");
      const queryType = queryParams.get("type");

      const queryParamsString = new URLSearchParams();
      if (queryDomain) {
        queryParamsString.append("domain", queryDomain);
      }
      if (queryType) {
        queryParamsString.append("type", queryType);
      }
      if (customerName.length > 2) {

        queryParamsString.append("customer_name", customerName[1]);
      }
      window.location.href = `https://aviatrix-org.web.app/?domain=${queryDomain}&type=${queryType}`
    
    } catch (error) {
      // Handle any unexpected errors
      window.snakAlert.error("Error while loading org chart data");
      console.error("Error while loading org chart data:", error);
    }
  };

  // Load data on initial component render
  useEffect(() => {
    load();
  }, []);

  // Render organization chart component if data is available
  return (
    <>
        {orgChartData?.clientSide?.length ||
        orgChartData?.aviatrixSide?.length ? (
          <MBOrganizationChart
            clientSide={orgChartData.clientSide}
            aviatrixSide={orgChartData.aviatrixSide}
          />
        ) : null}
    </>
  );
};

export default MBOrgChart;
